import { useMemo } from 'react';
import type { TellerUser } from '~/models/teller-user';
import { useFetchPaymentSubscriptionStatus } from './use-fetch-subscription-status';

export const useSubscriptionInfo = (tellerUser: TellerUser | undefined) => {
  const { paymentSubscriptionStatus } = useFetchPaymentSubscriptionStatus();

  const hasPaymentInformation = useMemo(() => {
    if (!tellerUser || !paymentSubscriptionStatus) {
      return false;
    }
    return (
      (tellerUser.isVipUser &&
        paymentSubscriptionStatus.hasActiveSubscription) ||
      paymentSubscriptionStatus.subscriptionNeedsAttention
    );
  }, [paymentSubscriptionStatus, tellerUser]);

  return {
    hasPaymentInformation,
  };
};
